module.exports = __webpack_public_path__ + "f72dfdd77383ca0269e11fb49283f555.MP3";